import {HttpClient} from "../../http/HttpClient.jsx";
import {message} from "antd";
import {StringBuilder} from "../../AppUtils.js";

export const createBid = async values => {
    const res = await HttpClient.safePost(`/api/bid/create`, values);

    if (res.error) {
        message.error(new StringBuilder("שגיאה בעת יצירת הצעת מחיר").append(`(${res.error})`).toString());
    } else {
        message.success("הצעת מחיר נוצרה בהצלחה");
    }

    return res;
};

export const updateBidByAdmin = async values => {
    const res = await HttpClient.safePost(`/admin/api/bids/${values.bidId}/updateBid`, {bid: values});

    if (res.error) {
        message.error(new StringBuilder("שגיאה בעת עדכון הצעת מחיר").append(`(${res.error})`).toString());
    } else {
        message.success("הצעת מחיר עודכנה בהצלחה");
    }

    return res;
};

export const updateBid = async values => {
    const res = await HttpClient.safePost(`/api/bids/${values.bidId}/updateBid`, {bid: values});

    if (res.error) {
        message.error(new StringBuilder("שגיאה בעת עדכון הצעת מחיר").append(`(${res.error})`).toString());
    } else {
        message.success("הצעת מחיר עודכנה בהצלחה");
    }

    return res;
};

export const addNoteToBid = async values => {
    const res = await HttpClient.safePost(`/api/bids/${values.bidId}/addNote`, {bid: values});

    if (res.error) {
        message.error(new StringBuilder("שגיאה בעת עדכון הצעת מחיר").append(`(${res.error})`).toString());
    } else {
        message.success("הצעת מחיר עודכנה בהצלחה");
    }

    return res;
};

export const addNoteToBidByAdmin = async values => {
    const res = await HttpClient.safePost(`/admin/api/bids/${values.bidId}/addNote`, {bid: values});

    if (res.error) {
        message.error(new StringBuilder("שגיאה בעת עדכון הצעת מחיר").append(`(${res.error})`).toString());
    } else {
        message.success("הצעת מחיר עודכנה בהצלחה");
    }

    return res;
};

export const updateBidStatus = async values => {
    const res = await HttpClient.safePost(`/api/bids/${values.bidId}/updateStatus`, {status: values.status});

    return res;
};

export const createOrderFromBid = async ({
    bidId,
    paymentType,
    creditCard,
    tenBisCreditCard,
    invoiceComment,
    invoicePONumber,
    separateInvoice,
    deliveryRequests,
    budgetCategories,
    targetUserId
}) => {
    try {
        const paymentDetails = {
            paymentType,
            ...(creditCard && {creditCard}),
            ...(tenBisCreditCard && {tenBisCreditCard}),
            ...(invoiceComment && {invoiceComment}),
            ...(invoicePONumber && {invoicePONumber}),
            ...(separateInvoice && {separateInvoice}),
            ...(deliveryRequests && {deliveryRequests}),
            ...(budgetCategories && {budgetCategories})
        };

        const params = new URLSearchParams();
        params.append("targetUserId", targetUserId);

        const res = await HttpClient.safePost(`/api/events/createOrderFromBid?${params.toString()}`, {
            bidId,
            paymentDetails
        });

        if (res.error) {
            message.error(new StringBuilder("שגיאה בעת יצירת הזמנה").append(`(${res.error})`).toString());
        } else {
            message.success("ההזמנה נוצרה בהצלחה");
        }

        return res;
    } catch (error) {
        message.error("שגיאה בעת יצירת הזמנה");
        return {error: error.message};
    }
};
